import { css } from 'styled-components'
const styles = css`
    padding-top:57px;
`

export default styles
    